"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typography = void 0;

var _stylitas = require("@creditas/stylitas");

var _fonts = require("./fonts");

const capitalizeFirstLetter = string => string.charAt(0).toUpperCase() + string.slice(1);

const buildertypography = device => (theme, name) => {
  const family = theme[`${device}${name}Family`];
  const size = theme[`${device}${name}Size`];
  const weight = theme[`${device}${name}Weight`];
  const lineHeight = theme[`${device}${name}LineHeight`];
  const letterSpacing = theme[`${device}${name}Spacing`];
  return (0, _stylitas.css)`
    font-family: ${family};
    font-size: ${size};
    font-weight: ${weight};
    line-height: ${lineHeight};
    letter-spacing: ${letterSpacing};
  `;
};

const typographyDesktop = buildertypography('desktop');
const typographyMobile = buildertypography('mobile');

const builderTypographyFns = (typographyFn, typos) => typos.reduce((acc, typo) => {
  acc[typo] = theme => (0, _stylitas.css)`
      ${typographyFn(theme, capitalizeFirstLetter(typo))}
    `;

  return acc;
}, {});

const desktop = builderTypographyFns(typographyDesktop, _fonts.typoDesktop);
const mobile = builderTypographyFns(typographyMobile, _fonts.typoMobile);
const typography = {
  desktop,
  mobile
};
exports.typography = typography;